<script lang="ts">
    import {onMount} from 'svelte'
    import {loadStripe} from '@stripe/stripe-js'
    import {createPaygCheckout} from "@docsndata/thesmartwashltd-bookings-core";
    import {
        aboutYouDetails,
        accessories,
        chosenDateOptions,
        chosenSlotOption,
        environmentId,
        operatorId,
        showAdmin,
        tenantId,
        totalPrice,
        totalPriceToTwoDecimalPlaces
    } from "./stores";
    import {stripeMetadata} from "./stripeMetadata";
    import {mandatory} from "@docsndata/lang-util";
    import {v4 as uuid} from 'uuid'
    import {push} from 'svelte-spa-router'
    import {exemplarService, fetchedCoupon, invitation} from "./state/appState";
    import DetailedTotal from "./DetailedTotal.svelte";
    import type {AmountWithoutDecimalPlaces, Metadata} from "@docsndata/stripe-cloud-functions-api";
    import {amountWithoutDecimalPlaces} from "@docsndata/stripe-cloud-functions-api";
    import {mandatoryEnvironment} from "@docsndata/stripe-types";
    import {StripePaymentForm} from "@docsndata/thesmartwashltd-booking-components";
    import {makeBookingDetails} from "./makeBookingDetails";
    import {requestPayment} from "./requestPayment";

    let stripe = null
    let clientSecret = null

    onMount(async () => {
        try {
            const bookingId = uuid()
            let metadata: Metadata
            let price: AmountWithoutDecimalPlaces
            if (window.location.href.startsWith("http://localhost")) {
                metadata = $chosenDateOptions ? stripeMetadata(mandatory($chosenDateOptions, "No selected product"), $chosenSlotOption, $accessories, $aboutYouDetails as any, $totalPriceToTwoDecimalPlaces, bookingId, $invitation, $operatorId, $fetchedCoupon) : {}
                price = $totalPrice.amount === 0 ? amountWithoutDecimalPlaces(500) : $totalPrice
            } else {
                metadata = stripeMetadata(mandatory($chosenDateOptions, "No selected product"), $chosenSlotOption, $accessories, $aboutYouDetails as any, $totalPriceToTwoDecimalPlaces, bookingId, $invitation, $operatorId, $fetchedCoupon)
                price = $totalPrice
            }

            await createPaygCheckout(price, "gbp", $tenantId, mandatoryEnvironment($environmentId), $aboutYouDetails.email, metadata)
                .then(async paygResponse => {
                    stripe = await loadStripe(paygResponse.publicKey)
                    clientSecret = paygResponse.clientSecret
                })
        } catch (error: any) {
            console.error(error)
        }
    })

    async function paymentComplete() {
        push("/thanks")
    }

    function sendPaymentRequest() {
        const bookingId = uuid()
        const bookingDetails = makeBookingDetails(mandatory($chosenDateOptions, "No selected product"), $chosenSlotOption, $accessories, $aboutYouDetails as any, $totalPriceToTwoDecimalPlaces, bookingId, $operatorId, $fetchedCoupon)
        requestPayment(bookingDetails)
            .then(() => window.location.href = "/admin")
            .catch(error => alert(error))
    }

</script>

<div class="mt-2 text-center">
    <h4>Payment</h4>

    <div>
        You chose
        {#if $exemplarService}
            the <strong>{$exemplarService.name}</strong> service at
        {/if}
        <strong>{$chosenSlotOption?.label}</strong> on <strong>{$chosenDateOptions?.id}</strong>
    </div>
    <div class="text-center">
        <DetailedTotal/>
    </div>

    {#if stripe && clientSecret}
        <StripePaymentForm {stripe} {clientSecret} on:paymentComplete={paymentComplete}/>
        {#if $showAdmin}
            <br/>
            <button class="btn btn-secondary pay-now-button px-5 py-2" on:click={sendPaymentRequest}>Send Payment
                Request
            </button>
        {/if}

    {:else}
        Loading...
    {/if}
</div>

